import { CommitteeDto } from './committee.dto';
import { CommitteeMeetingDto } from './committee-meeting.dto';
import { ProfileMin } from 'src/app/profiles/shared/profile-min.model';

export interface CommitteeMeetingAttendeeDto {
  AttendeeID: number;
  MeetingID: number;
  CommitteeID: number;
  ProfileID: number;
  DateCreated: Date;
  DateChanged: Date;
  ChangedBy: string;

  Committee: CommitteeDto;
  CommitteeMeeting: CommitteeMeetingDto;
  Profile: ProfileMin;
}

export function initializedCommitteeMeetingAttendeeDto(meetingId: number, committeeId: number, profileId: number) {
  const now = new Date();
  return {
    MeetingID: meetingId,
    CommitteeID: committeeId,
    ProfileID: profileId,
    DateCreated: now,
    DateChanged: now,
  } as CommitteeMeetingAttendeeDto;
}
